import { AlertTriangleIcon, InfoIcon } from 'lucide-react'
import { memo, type ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { Alert, AlertDescription } from '@/components/ui/alert'
import { cn } from '@/lib/utils'

import type { SeatUsageAlertProps } from './members.interface'

/**
 * Displays seat usage information for organization members.
 * Shows warning styling when at or near the member limit.
 */
const SeatUsageAlertBase: React.FC<SeatUsageAlertProps> = ({
  currentCount,
  maxCount,
  subscriptionHref,
  className,
}): ReactNode => {
  if (maxCount === null || maxCount === 0) {
    return null
  }

  const isAtLimit = currentCount >= maxCount
  const variant = isAtLimit ? 'destructive' : 'default'
  const Icon = isAtLimit ? AlertTriangleIcon : InfoIcon

  return (
    <Alert variant={variant} className={cn('seat-usage-alert', className)}>
      <Icon className="size-4" />
      <AlertDescription className="seat-usage-alert-description">
        Using {currentCount} {currentCount === 1 ? 'seat' : 'seats'} out of {maxCount} available.{' '}
        <Link to={subscriptionHref} className="seat-usage-alert-link font-medium underline">
          To get more seats go here
        </Link>
      </AlertDescription>
    </Alert>
  )
}

export const SeatUsageAlert = memo(SeatUsageAlertBase)

SeatUsageAlert.displayName = 'SeatUsageAlert'
